/**
 * @function getBootstrapModal
 * @returns {Function} Bootstrap Modal class
 * @description Loads Bootstrap Modal only once and reuses the same global reference.
 */
function getBootstrapModal() {
    window.bs = window.bs || {};

    if (!window.bs.Modal) {
        const modalModule = require('bootstrap/js/dist/modal'); // eslint-disable-line global-require
        window.bs.Modal = modalModule.default || modalModule;
    }

    return window.bs.Modal;
}

export default getBootstrapModal;
